@if (!bankAccount()?.czyZagraniczne!) {
  <div class="grid grid-cols-1 gap-8">
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Lokalizacja rachunku bankowego'"
        [data]="'Polska'"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Numer konta bankowego'"
        [data]="
          bankAccount()?.numerKonta
            ? (bankAccount()?.numerKonta! | bankAccountFormat)
            : 'Brak numeru konta bankowego'
        "
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    @if (bankAccount()?.nieJestWlascicielem) {
      <div tabindex="0">
        <app-preview-data-wrapper
          [label]="'Imię  i nazwisko właściciela rachunku'"
          [data]="bankAccount()?.daneWlasciciela"
          additionalCssClasses="font-bold"
        ></app-preview-data-wrapper>
      </div>
    } @else {
      <div tabindex="0">
        <app-preview-data-wrapper
          [label]="'Nie jestem właścicielem podanego rachunku bankowego'"
          [data]="bankAccount()?.nieJestWlascicielem"
          [dataType]="PreviewDataType.CHECKBOX"
        ></app-preview-data-wrapper>
      </div>
    }
  </div>
} @else {
  <div class="grid grid-cols-2 gap-8">
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Lokalizacja rachunku bankowego'"
        [data]="'Państwo UE/EFTA lub Wielka Brytania'"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Numer konta bankowego'"
        [data]="bankAccount()?.numerKonta! | bankAccountFormat"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Międzynarodowy numer BIC/SWIFT'"
        [data]="bankAccount()?.identyfikatorBanku"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
    <div tabindex="0">
      <app-preview-data-wrapper
        [label]="'Nazwa i adres banku'"
        [data]="bankAccount()?.daneBanku"
        additionalCssClasses="font-bold"
      ></app-preview-data-wrapper>
    </div>
  </div>
}
